import { Actions, ActionTypes } from '@appStore/account/actions';
import { UserMarketingSetting } from '@model';

export interface State {
  loadingSetting: boolean;
  loadedSetting: boolean;
  data: UserMarketingSetting;
}

export const initialState: State = {
  loadingSetting: false,
  loadedSetting: false,
  data: null
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.UserMarketingSettingsLoadData:
      return { ...state, loadedSetting: false, loadingSetting: true };
    case ActionTypes.UserMarketingSettingsLoadDataSuccess:
      return { ...state, loadedSetting: true, loadingSetting: false, data: action.payload };
    case ActionTypes.UserMarketingSettingsLoadDataFail:
      return { ...state, loadedSetting: false, loadingSetting: false };
    case ActionTypes.UserMarketingSettingsUpdate:
      return { ...state, loadingSetting: true };
    case ActionTypes.UserMarketingSettingsUpdateSuccess:
      return { ...state, loadingSetting: false, data: action.payload };
    case ActionTypes.UserMarketingSettingsUpdateFail:
      return { ...state, loadingSetting: false };
  }
  return state;
}

export const getUserMarketingSetting = (state: State) => state.data;
export const getLoadedUserMarketingSettings = (state: State) => state.loadedSetting;
export const getLoadingUserMarketingSettings = (state: State) => state.loadingSetting;
